import React from 'react';
import { Numbers } from '@weezevent/nacre';
import i18n from 'i18next';
import Rate from './Rate';
import { getInventoryName } from '../../utils';
import useAppContext from '../../../../../../context/useAppContext';
import css from '../../../styles.module.css';

export default function Inventory({ inventory, rates, form }) {
    const { locale } = i18n;
    const [{ event }] = useAppContext();

    const totalAmount = React.useMemo(() => {
        let total = 0;
        rates.forEach(selected_rate => {
            total += selected_rate.quantity * selected_rate.price;
        });
        return total;
    }, [rates]);

    const ratesFilter = React.useMemo(() => {
        let properRates = [];
        rates.forEach(rate => {
            if (form.attendees.find(attendee => attendee.rate_id === rate.rate.id)) {
                properRates.push(rate);
            }
        });
        return properRates;
    }, [form.attendees, rates]);

    if (!rates.length) {
        return null;
    }

    return (
        <>
            <div className={`${css['summary-ticket-item']} ${form.attendees.length === 0 ? css['empty-attendees'] : ''}`}>
                <div>{getInventoryName(event.isFakeSeating(), inventory, event.timezone)}</div>
                <Numbers className={css['summary-price']} value={totalAmount} locale={locale} currency={form.currency} showNullDecimal />
            </div>
            {Boolean(form.attendees.length) && (
                <div className={css['summary-ticket-subitem']}>
                    {ratesFilter.map(s_rate => (
                        <Rate key={s_rate.rate.id} rate={s_rate} form={form} />
                    ))}
                </div>
            )}
        </>
    );
}
